import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import IconLoader from "@/features/Common/components/IconLoader";
import ScreenWrapper from "../../Common/ScreenWrapper";
import BreathingRateCard from "./InfoCard";
import BreathingRateChart, {
  BreathingRateDataPoint,
} from "./BreathingRateChart";
import HereToHelpCard from "../../HereToHelpCard";
import BreathingRateModal from "./BreathingRateModal";
import { WellnessScoreStatus } from "../../Common/types";

export interface MyBreathingRateScreenProps {
  metricValue: string;
  status: WellnessScoreStatus;
  lastUpdated?: string;
  chartData: BreathingRateDataPoint[];
  onBack?: () => void;
  onOpenManualEntry?: () => void;
}

export default function MyBreathingRateScreen({
  metricValue,
  status,
  lastUpdated,
  chartData,
  onBack,
  onOpenManualEntry,
}: MyBreathingRateScreenProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const handleBack = onBack ?? (() => navigate(-1));

  return (
    <>
      <ScreenWrapper
        onBack={handleBack}
        title={t("HealthChart.breathingRateModal.card.title")}
        description={t("HealthChart.breathingRateModal.card.description")}
        onInfoClick={() => setIsInfoModalOpen(true)}
      >
        <Stack gap={2}>
          <BreathingRateCard
            metricValue={metricValue}
            status={status}
            lastUpdated={lastUpdated}
            onManualEntryClick={onOpenManualEntry}
          />
          <BreathingRateChart data={chartData} />
          <HereToHelpCard
            title={t("HereToHelpCard.title")}
            description={t("HereToHelpCard.description")}
            button={{
              text: t("HereToHelpCard.button.text"),
              icon: <IconLoader icon="SpeakToADoctorIcon" />,
            }}
          />
        </Stack>
      </ScreenWrapper>

      <BreathingRateModal
        isOpen={isInfoModalOpen}
        onClose={() => setIsInfoModalOpen(false)}
      />
    </>
  );
}
